import { CheckBox } from "@shltelemedicine/shl-ui-lib";
import { FormattedMessage } from "react-intl";
import { v4 as uuidv4 } from "uuid";
import { IAction } from "../../../../../models/ecg.interface";
import EcgAction from "../EcgAction/EcgAction";

type SingleEcgActionProps = {
  action: IAction;
  onChange: Function;
  disabled: boolean;
  dirty: boolean;
};

const SingleEcgAction = ({
  action,
  onChange,
  disabled,
  dirty,
}: SingleEcgActionProps) => {
  return (
    <div className="d-flex space-between">
      <EcgAction severity={action.severity} displayName={action.displayName} />
      <div className="d-flex ml-2">
        <CheckBox
          className="mx-1"
          key={uuidv4()}
          type="radio"
          name={action.key}
          checked={action.value === false && dirty}
          label={
            <FormattedMessage
              id="ECG_DETAILS.ACTION_REQUIRED.LABEL.NO"
              defaultMessage="No"
            />
          }
          onChange={(e) => onChange(false, e)}
          disabled={disabled}
        />
        <CheckBox
          className="mx-1"
          key={action.key}
          type="radio"
          name={action.key}
          checked={action.value}
          label={
            <FormattedMessage
              id="ECG_DETAILS.ACTION_REQUIRED.LABEL.YES"
              defaultMessage="Yes"
            />
          }
          onChange={(e) => onChange(true, e)}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default SingleEcgAction;
